import React from "react";
import schools from "../assets/data/schools";
import logo from "../assets/img/logo.webp";

const metaInfo = [
    {
        id: "home",
        name: "school-of-management",
        metatitle: "ISBM School of Management | Management Program courses",
        metadesc:
            "Transform your career with ISBM University's School of Management. Explore management programs, expert faculty, industry-focused curriculum and excellent career opportunities.",
    },
];

function MetaInfo({ param = null, id }) {
    let info = null;
    if (param === "school" || param === "course") {
        info = schools.find((item) => item.id === id) || schools[0];
    } else {
        info = metaInfo.find((item) => item.id === id) || metaInfo[0];
    }

    const url = window.location.href;
    return (
        <>
            <title>{info.metatitle}</title>
            <meta name="description" content={info.metadesc} />
            <meta
                name="SearchEngines"
                content="Google, Bing, Overture, Yahoo, AOL, Infoseek, LookSmart, Excite, Hotbot, Lycos, CNET,
                DogPile, Ask Jeeves, Teoma, Snap, WebCrawler, AltaVista, GigaBlast, isoHunt, Kayak, MetaCrawler"
            />
            <meta name="Robots" content="INDEX, FOLLOW" />
            <meta name="Author" content="ISBM University, isbmuniversity.edu.in/" />
            <meta name="Robots" content="INDEX,ALL" />
            <meta name="YahooSeeker" content="INDEX, FOLLOW" />
            <meta name="msnbot" content="INDEX, FOLLOW" />
            <meta name="googlebot" content="Default, follow" />
            <meta name="owner" content="isbmuniversity.edu.in/" />
            <meta name="language" content="English" />
            <meta name="revisit-after" content="2 days" />
            <meta property="og:title" content={info.metatitle} />
            <meta property="og:description" content={info.metadesc} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={logo} />
            <meta property="og:image:alt" content="ISBM University" />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="ISBM University" />
            <meta name="twitter:title" content={info.metatitle} />
            <meta name="twitter:description" content={info.metadesc} />
            <meta name="twitter:image:src" content={logo} />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:site" content="@ISBMUniversity" />
            <meta name="twitter:creator" content="@ISBMUniversity" />
            <meta name="twitter:domain" content="https://isbmuniversity.edu.in/" />
            <meta property="twitter:account_id" content="758619542734053376" />
            <div
                className="d-none"
                dangerouslySetInnerHTML={{
                    __html: info.schema,
                }}
            ></div>
        </>
    );
}

export default MetaInfo;
